export const POSTHOG_EVENTS = {
    CHECKIN_CREATED: 'checkin-created',
    BUTTON_CLICKED: 'button_clicked',
    FILE_DOWNLOADED: 'file_downloaded',
    REPORT_DOWNLOADED: 'report_downloaded',
    VIDEO_ACTIONED: 'video_actioned',
    LOGIN: 'login',
    REPORT_INTERACTION: 'report_interaction',
};
